<ng-template #popTemplate><div [innerHtml]="helpText"></div></ng-template>
<i class="fas fa-info-circle" [popover]="popTemplate" [outsideClick]="true" trigger="focus" container="body" boundariesElement="viewport"></i>